import { MapPin, Navigation, Phone } from "lucide-react";
import { BUSINESS, WA_MESSAGES } from "@/config/business";
import { WhatsAppButton } from "./CtaButtons";

const LocationSection = () => (
  <section id="location" className="scroll-mt-24 bg-[#F4EFEA] py-16 sm:py-24">
    <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-8 lg:grid-cols-2 lg:gap-16">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#9E7B36]">
          Find Us
        </p>
        <h2 className="mt-3 font-serif text-3xl font-medium tracking-tight text-[#1C1917] sm:text-4xl">
          Visit GK Wellness &amp; Luxury Spa
        </h2>
        <address className="mt-6 space-y-4 not-italic">
          <p className="flex items-start gap-3 text-sm leading-relaxed text-[#57534E] sm:text-base">
            <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#9E7B36]" aria-hidden="true" />
            <span>
              {BUSINESS.address}
              <span className="mt-1 block font-semibold text-[#1C1917]">{BUSINESS.landmark}</span>
            </span>
          </p>
          <p className="flex items-center gap-3 text-sm sm:text-base">
            <Phone className="h-5 w-5 shrink-0 text-[#9E7B36]" aria-hidden="true" />
            <a
              href={BUSINESS.tel}
              data-testid="location-phone-link"
              className="font-semibold text-[#1C1917] underline-offset-4 hover:underline"
            >
              {BUSINESS.phoneDisplay}
            </a>
          </p>
        </address>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href={BUSINESS.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="location-directions-btn"
            aria-label="Get directions to GK Wellness on Google Maps"
            className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full bg-[#C5A059] px-6 py-3 text-sm font-semibold text-white shadow-[0_4px_20px_-2px_rgba(197,160,89,0.5)] transition-[background-color,transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:bg-[#B38D46] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059] focus-visible:ring-offset-2 sm:text-base"
          >
            <Navigation className="h-5 w-5" aria-hidden="true" />
            Get Directions
          </a>
          <WhatsAppButton
            message={WA_MESSAGES.visit}
            label="WhatsApp Us"
            testId="location-whatsapp-btn"
          />
        </div>
      </div>
      <div className="relative overflow-hidden rounded-3xl bg-[#1C1917] p-8 text-center sm:p-12">
        <div
          className="pointer-events-none absolute -top-24 right-0 h-56 w-56 rounded-full bg-[#C5A059]/15 blur-3xl"
          aria-hidden="true"
        />
        <img
          src={BUSINESS.logo}
          alt="GK Wellness & Luxury Spa monogram logo"
          loading="lazy"
          decoding="async"
          className="relative mx-auto h-32 w-32 rounded-full object-cover ring-2 ring-[#C5A059]/50 sm:h-40 sm:w-40"
          width="160"
          height="160"
        />
        <p className="relative mt-6 font-serif text-2xl font-medium text-white sm:text-3xl">
          Singasandra, Bengaluru
        </p>
        <p className="relative mt-2 text-sm tracking-wide text-[#EED8A1]">
          Near Manipal County Road
        </p>
        <p className="relative mt-6 text-xs uppercase tracking-[0.3em] text-stone-400">
          {BUSINESS.tagline}
        </p>
      </div>
    </div>
  </section>
);

export default LocationSection;
